import { matchPath } from 'react-router-dom';

const ROUTE_MAPPING = [
  // Doctor / Clinical
  { path: '/doctor-dashboard', topic: 'dashboard-doctor' },
  { path: '/consultation-notes-screen', topic: 'consultation-workspace' },
  { path: '/consultation-workspace', topic: 'consultation-workspace' },
  { path: '/prescription-management', topic: 'consultation-workspace' }, // DEPRECATED: redirects to consultation-workspace
  
  // Nursing
  { path: '/nursing-dashboard', topic: 'dashboard-nurse' },
  { path: '/bed-management', topic: 'bed-management' },
  { path: '/medication-schedule', topic: 'medication-schedule' },
  
  // Patient
  { path: '/patient-registration', topic: 'patient-registration' },
  { path: '/patient-records', topic: 'patient-records' },
  { path: '/patient-full-view', topic: 'patient-full-view' },
  { path: '/patient-self-register', topic: 'patient-self-register' },
  { path: '/patient-register-form', topic: 'patient-self-register' },
  
  // Pharmacy
  { path: '/pharmacy-dashboard', topic: 'pharmacy-dashboard' },
  
  // Laboratory
  { path: '/laboratory-dashboard', topic: 'laboratory-dashboard' },
  
  // Accounts & Billing
  { path: '/accounts-dashboard', topic: 'accounts-dashboard' },
  { path: '/service-management', topic: 'service-management' },
  
  // Admin
  { path: '/admin-dashboard', topic: 'admin-dashboard' },
  { path: '/user-administration-dashboard', topic: 'user-administration' },
  { path: '/user-creation-interface', topic: 'user-administration' },
  { path: '/facility-management', topic: 'facility-management' },
  { path: '/hospital-configuration', topic: 'hospital-configuration' },
  { path: '/pulse-dashboard', topic: 'pulse-dashboard' },
  { path: '/duty-roster', topic: 'duty-roster' },
  
  // Profile & Auth
  { path: '/login', topic: 'login' },
  { path: '/user-profile', topic: 'user-profile' },
  { path: '/profile-setup', topic: 'user-profile' },
  { path: '/accept-invite', topic: 'accept-invite' },
  { path: '/authentication-portal', topic: 'authentication-portal' },
  
  // Default
  { path: '/', topic: 'general-introduction' }
];


export const getHelpTopicForPath = (pathname) => {
  // Find the first matching route
  const match = ROUTE_MAPPING.find(route => 
    matchPath({ path: route.path, end: false }, pathname)
  );
  
  return match ? match.topic : 'general-introduction';
};

// Export all topic IDs for search/index purposes
export const getAllTopicIds = () => {
  return [...new Set(ROUTE_MAPPING.map(r => r.topic))];
};
